import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout";
import api from "../../api";

const PALETTE = [
  ["#1D9AEC", "#6366F1"],
  ["#10B981", "#1D9AEC"],
  ["#F59E0B", "#EF4444"],
  ["#6366F1", "#EC4899"],
  ["#0891B2", "#10B981"],
];

export default function JuryEventsPage() {
  const navigate = useNavigate();
  const [events, setEvents] = useState(null);

  useEffect(() => {
    api.get("/jury/me")
      .then(res => setEvents(res.data.data.assignedEvents || []))
      .catch(() => setEvents([]));
  }, []);

  return (
    <Layout title="My Events" subtitle="Events you have been assigned to review">

      {/* Skeletons */}
      {!events && (
        <div style={grid}>
          {[1,2,3].map(i => (
            <div key={i} style={cardBase}>
              <div className="skeleton" style={{ height: 48, width: 48, borderRadius: 12, marginBottom: 16 }} />
              <div className="skeleton" style={{ height: 14, width: "75%", marginBottom: 8 }} />
              <div className="skeleton" style={{ height: 10, width: "40%" }} />
            </div>
          ))}
        </div>
      )}

      {/* Empty state */}
      {events && events.length === 0 && (
        <div style={{
          textAlign: "center", padding: "80px 20px",
          background: "#fff", borderRadius: 12,
          border: "1px solid #E2E8F0", boxShadow: "var(--shadow-sm)",
        }}>
          <div style={{ fontSize: 52, marginBottom: 14 }}>📭</div>
          <h3 style={{ fontSize: 16, fontWeight: 700, color: "#0F172A", margin: "0 0 8px" }}>
            No events assigned yet
          </h3>
          <p style={{ fontSize: 13.5, color: "#94A3B8", margin: 0 }}>
            Your administrator will assign events to you shortly.
          </p>
        </div>
      )}

      {/* Events grid */}
      {events && events.length > 0 && (
        <div style={grid}>
          {events.map((ev, idx) => {
            const [c1, c2] = PALETTE[idx % PALETTE.length];
            return (
              <div
                key={ev._id}
                className="card-hover"
                onClick={() => navigate(`/jury/events/${ev._id}/nominations`)}
                style={{
                  ...cardBase,
                  animationDelay: `${idx * 50}ms`,
                  animation: "fadeIn 0.3s ease forwards",
                  opacity: 0,
                }}
              >
                {/* Gradient top bar */}
                <div style={{
                  position: "absolute", top: 0, left: 0, right: 0, height: 3,
                  background: `linear-gradient(90deg, ${c1}, ${c2})`,
                  borderRadius: "10px 10px 0 0",
                }} />

                {/* Icon */}
                <div style={{
                  width: 48, height: 48, borderRadius: 12,
                  background: `linear-gradient(135deg, ${c1}18, ${c2}18)`,
                  border: `1px solid ${c1}30`,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  fontSize: 22, marginBottom: 16,
                }}>🎯</div>

                <h3 style={{
                  margin: "0 0 8px", fontSize: 14.5, fontWeight: 700,
                  color: "#0F172A", lineHeight: 1.3,
                }}>{ev.eventName}</h3>

                <div style={{
                  display: "flex", alignItems: "center", gap: 6,
                  fontSize: 12.5, fontWeight: 600, color: c1, marginTop: 12,
                }}>
                  Review Nominations →
                </div>
              </div>
            );
          })}
        </div>
      )}
    </Layout>
  );
}

const grid    = { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 18 };
const cardBase = {
  background: "#fff", border: "1px solid #E2E8F0",
  borderRadius: 10, padding: "22px 20px 20px",
  position: "relative", overflow: "hidden",
  boxShadow: "var(--shadow-sm)",
};
